export default {
  data() {
    const pageSize = Number(window.localStorage.getItem('pageSize')) || 25;
    return {
      selectedIds: [],
      filterData: [],
      searchTerm: '',
      isLoading: true,
      isSaving: false,
      updateProgress: {
        total: 0,
        completed: 0,
        failed: 0
      },
      pagin: {
        current: 1,
        pageSize,
        total: 0
      },
      tableSize: {
        height: 300,
        width: ''
      }
    };
  },
  computed: {
    progressPercent() {
      if (!this.updateProgress.total) return 0;
      return Math.round((this.updateProgress.completed / this.updateProgress.total) * 100);
    }
  },
  created() {
    this._searchDebounceTimer = null;
  },
  beforeDestroy() {
    clearTimeout(this._searchDebounceTimer);
  },
  methods: {
    paginChange(pagin) {
      this.pagin = { ...pagin };
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onSelectionChange(visibleSelectedIds) {
      const visibleIds = new Set(this.filterData.map(item => item.id));
      const hiddenSelectedIds = this.selectedIds.filter(id => !visibleIds.has(id));
      this.selectedIds = Array.from(new Set([...hiddenSelectedIds, ...visibleSelectedIds]));
    },
    onSearch(event) {
      this.searchTerm = event.target.value;
      clearTimeout(this._searchDebounceTimer);
      this._searchDebounceTimer = setTimeout(() => {
        this.filter();
      }, 300);
    },
    pruneSelection(allItems) {
      const selectedIdSet = new Set(this.selectedIds);
      allItems.forEach(item => {
        item.isChecked = selectedIdSet.has(item.id);
      });
    },
    async executeBatchUpdates(ids, updateFn, batchSize = 5) {
      this.isSaving = true;
      this.updateProgress = { total: ids.length, completed: 0, failed: 0 };
      const results = { success: [], failed: [] };

      for (let i = 0; i < ids.length; i += batchSize) {
        const batch = ids.slice(i, i + batchSize);
        await Promise.all(
          batch.map(async (id) => {
            try {
              await updateFn(id);
              results.success.push(id);
            } catch (error) {
              console.error(`Failed to update ${id}:`, error);
              results.failed.push(id);
              this.updateProgress.failed++;
            }
            this.updateProgress.completed++;
          })
        );
      }

      this.isSaving = false;
      return results;
    },
    showBulkSaveConfirm(count, entityName) {
      const plural = count > 1 ? 's' : '';
      return new Promise((resolve) => {
        this.$confirm({
          title: `Update ${count} ${entityName}${plural}?`,
          content: `Are you sure you want to apply changes to ${count} ${entityName}${plural}?`,
          okText: 'Yes, Update',
          okType: 'primary',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false)
        });
      });
    }
  }
};
